import { render, staticRenderFns } from "./Tabs.vue?vue&type=template&id=446cbff7&"
var script = {}
import style0 from "./Tabs.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports